import { IMenuItem } from "@aecom/core";

// application table
export const correspondenceAppId = "8a011297-0baf-11ea-917a-027e1b1809fa";

// active directory role
export const NA = "N/A";

export const productName = "Correspondence";

export const productSubtitle = "";

export const productMaintitle = "NYC BBJ PROGRAM";

export const appitems: IMenuItem[] = [
  {
    name: "Support",
    icon: "icon-action_app_support",
    id: "support",
    externalurl:
      "https://apps.powerapps.com/play/c04c6371-a3a6-4b25-a94c-9fe7fd35a16b?tenantId=bfb413d6-9a23-4cd3-a58d-e141aaf2948a",
  },
];